export default __webpack_public_path__ + "static/media/image-39.557a0c64.png";